import { useMemo } from "react";

import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { queryKeys } from "@/services/react-query.service/query-keys";
import { useQuery } from "@tanstack/react-query";

import { getSectorQueryDocument } from "./sector.gql";

export interface UseGetSectorProps {
  id: string;
  enabled?: boolean;
}

export const useGetSector = ({ id, enabled = true }: UseGetSectorProps) => {
  const queryResult = useQuery({
    queryKey: queryKeys.sectors.detail(id),
    queryFn: async () => {
      if (!id) {
        throw new Error("Sector ID is required");
      }
      const client = createOperationClient("GetSector");
      const data = await client.request(getSectorQueryDocument, { input: { id } });
      return data.sector;
    },
    enabled: enabled && !!id,
    staleTime: 5 * 60 * 1000, // 5 minutes for individual items
  });

  const sector = useMemo(() => {
    return queryResult.data ?? null;
  }, [queryResult.data]);

  return {
    sector,
    loading: queryResult.isLoading,
    error: queryResult.error,
    queryResult,
  };
};
